import { jsx as _jsx } from "react/jsx-runtime";
import { UnstyledButton, CopyButton, Tooltip } from '@mantine/core';
import { getPrimaryColor } from '../column.utils';
export const MRT_CopyButton = ({ cell, children, table, }) => {
    const { options: { localization, mantineCopyButtonProps }, } = table;
    const { column, row } = cell;
    const { columnDef } = column;
    const mTableBodyCellCopyButtonProps = mantineCopyButtonProps instanceof Function
        ? mantineCopyButtonProps({ cell, column, row, table })
        : mantineCopyButtonProps;
    const mcTableBodyCellCopyButtonProps = columnDef.mantineCopyButtonProps instanceof Function
        ? columnDef.mantineCopyButtonProps({
            cell,
            column,
            row,
            table,
        })
        : columnDef.mantineCopyButtonProps;
    const buttonProps = Object.assign(Object.assign({}, mTableBodyCellCopyButtonProps), mcTableBodyCellCopyButtonProps);
    return (_jsx(CopyButton, { value: cell.getValue(), children: ({ copied, copy }) => {
            var _a;
            return (_jsx(Tooltip, { color: copied ? 'green' : undefined, withinPortal: true, openDelay: 1000, label: (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.title) !== null && _a !== void 0 ? _a : (copied ? localization.copiedToClipboard : localization.clickToCopy), children: _jsx(UnstyledButton, Object.assign({}, buttonProps, { onClick: (e) => {
                        e.stopPropagation();
                        copy();
                    }, sx: (theme) => (Object.assign({ backgroundColor: 'transparent', border: 'none', borderRadius: '4px', color: 'inherit', cursor: 'copy', fontFamily: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', justifyContent: 'inherit', letterSpacing: 'inherit', margin: '-4px', minWidth: 'unset', padding: '4px', textAlign: 'inherit', textTransform: 'inherit', '&:active': {
                            transform: 'translateY(1px)',
                        }, '&:hover': {
                            backgroundColor: theme.fn.rgba(getPrimaryColor(theme), 0.1),
                        } }, ((buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx) instanceof Function
                        ? buttonProps.sx(theme)
                        : buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx))), title: undefined, children: children })) }));
        } }));
};
//# sourceMappingURL=MRT_CopyButton.js.map